<template>
  <section>
    <div @click="showEventDetails()" class="calendarDayItem" v-if="checkTitle">
      <div class="calendarItem" :style="style">
        <p>{{ event.title }}</p>
      </div>
    </div>
    <div v-if="event.showDetails" class="detailBox">
        <EventDetails :event="this.event" />
    </div>
  </section>
</template>

<script>
import EventDetails from "@/components/calendar/EventDetails";

export default {
  props: ["event", "events"],

  components: {
    EventDetails
  },


  data: () => ({}),
  mounted(){
  },

  computed: {
      style () {
        var color = "";

        switch(this.event.type){
          case "class":
            color = "#16a085"
            break;
          case "assessment":
            color = "#e74c3c";
            break;
          case "assignment":
            color = "#f39c12";
            break;
          case "office":
            color = "#0984e3";
            break;
          case "other":
            color = "#a55eea"
            break;

        }
        return {
          "background-color": color,
          };
      },
      checkTitle(){
        if(this.event.title == null){
          return false;
        }
        return true;
      }
    },

  methods:{
    getDateInMs(date) {
      return new Date(date).getTime();
    },

    showEventDetails() {
      this.event.showDetails = !this.event.showDetails;
      this.hidePreviousEventDetails(this.event);
    },

    hidePreviousEventDetails(event) {
      for (const index in this.events) {
        if (this.events[index] != event) {
          this.events[index].showDetails = false;
        }
      }
    },
  },
};
</script>

<style  scoped>
p {
  color: white;
  font-size: 12px;
}

.emptyItem{
  padding: 10px 0px 10px;
  pointer-events: none;
}

.calendarItem {
  position: absolute;
  margin: 0 2px 2px 0px;
  border-radius: 5px;
  padding-left: 5px;
  text-align: start;
  cursor: pointer;
  margin-top: -10px;
  z-index: 2;
  width: 75%;
}

.calendarBlock{
    position: relative;
    background-color: transparent;
    margin: 0 2px 2px 0px;
    padding-left: 5px;
    text-align: start;
    cursor: pointer;
    z-index: 2;
}

.red{
  color: transparent;
}
</style>